"use strict";

var enumerationValues = new Set(["", "arraybuffer", "blob", "document", "json", "text"]);
exports.enumerationValues = enumerationValues;

exports.convert = function convert(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? "The provided value" : _ref$context;

  var string = "".concat(value);

  if (!enumerationValues.has(string)) {
    throw new TypeError("".concat(context, " '").concat(string, "' is not a valid enumeration value for XMLHttpRequestResponseType"));
  }

  return string;
};